import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';


import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { MyPATDialog, MyPATIconButton, MyPATPopMenu, MenuData } from '../../../common';

import contentService from '../../../mylibrary/services/contentService';
import TestPreview from '../../../mylibrary/components/ContentPreview/TestPreview';
import ContentMoreMenu from '../MilestoneDetails/ContentMoreMenu';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Typography,
	Paper,
	Grid,
	Checkbox,
	IconButton,
	Chip,
	Button
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
	Launch as LaunchIcon,
	MoreVert as MoreIcon
} from '@material-ui/icons';


import { MyPATLink, dateService } from '../../../common';
import ContentData from '../../../mylibrary/types/ContentData';
import ContentDataDefault from '../../../mylibrary/types/ContentDataDefault';
import { styles } from '../../styling/component/MilestoneDetails/ContentCard'



//@ts-ignore
interface ContentCardProps extends WithStyles<typeof styles> {
	classes: any,
	content: ContentData,
	userId: string,
	contentType: any,
	contentSubtype: any,
	onViewDetailsClick: Function,
	onFavouriteClick: Function,
	setContentSelected: Function,
	isInSelectedContent: Function,
	closeConceptModel: Function,
	openConceptModel: Function,
	index: number,
	assigmentCount: number,
	cardFlag: string,
	onScheduleClick: Function,
	onSetDisplayNameClick: (contentId:string) => void,
}
interface ContentCardState {
	previewDialogOpen: boolean
	previewTestKey: string
	previewContent: any
}


class ContentCard extends Component<ContentCardProps, ContentCardState>{
	defaultContent: any = null;
	contentTypeIcon: any = {
		"question": "/assets/img/mylibrary/content-type/question.png",
		"studymaterial": "/assets/img/mylibrary/content-type/notes.png",
		"sampleproblem": "/assets/img/mylibrary/content-type/notes.png",
		"formulas": "/assets/img/mylibrary/content-type/maths.png",
		"videos": "/assets/img/mylibrary/content-type/play.png",
		"audios": "/assets/img/mylibrary/content-type/play.png",
		"testpapers": "/assets/img/mylibrary/content-type/test.png"
	}

	constructor(public props: ContentCardProps) {
		super(props);
		this.defaultContent = ContentDataDefault
		this.state = {
			previewDialogOpen: false,
			previewTestKey: '',
			previewContent: ''
		}

		this.defaultContent = ContentDataDefault;
		this.handlePreviewDialogOpen = this.handlePreviewDialogOpen.bind(this);
		this.handlePreviewDialogClose = this.handlePreviewDialogClose.bind(this);
		this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
	}



	formatPercentage(val: any) {
		return val && !isNaN(val) ? parseInt(val) : "0"
	}

	getContentStatus = () => {
		let contentStatus:string = '';
		const content = !this.props.content ? this.defaultContent : this.props.content;

		if (content.type == 'testpapers') {
			contentStatus = 'planned';
			
			if (content.isSubmissionDate) {
				contentStatus = 'live';
			} else if (content.isUnlocked) {
				if (content.submissionDate && new Date(content.submissionDate).getTime() <= new Date().getTime()) {
					contentStatus = 'live';
				} else if (content.submissionDate && new Date(content.submissionDate).getTime() > new Date().getTime()) {
					contentStatus = 'upcoming';
				}
			} else {
				if (content.submissionDate && new Date(content.submissionDate).getTime() <= new Date().getTime()) {
					contentStatus = 'live';
				} else if (content.submissionDate && new Date(content.submissionDate).getTime() > new Date().getTime()) {
					contentStatus = 'upcoming';
				} else {
					contentStatus = 'planned';
				}
			}
		}
		return contentStatus;
	}

	renderContentStatus = () => {
		const contentStatus = this.getContentStatus();
		const classes = this.props.classes;
		
		switch(contentStatus) {
			case 'live': {
				return (
					<Typography variant="body1" className={cx(classes.liveButton, classes.statusButton)}>
						Live
					</Typography>
				)
			}
			case 'upcoming': {
				return (
					<Typography variant="body1" className={cx(classes.plannedButton, classes.statusButton)}>
						Upcoming
					</Typography>
				)
			}
			case 'planned': {
				return (
					<Typography variant="body1" className={cx(classes.plannedButton, classes.statusButton)}>
						Planned
					</Typography>
				)
			}
		}
	}

	getContentPreview(key: string) {
		contentService.details(key).then((c: any) => {

			if (!_.isEmpty(c)) {


				this.setState({ previewContent: c });
			}
		})
	}


	handlePreviewDialogOpen = (id: string, type: string) => {
		this.getContentPreview(id + type);
		this.setState({
			previewDialogOpen: true,
			previewTestKey: id,
		});
	};
	handlePreviewDialogClose = () => this.setState({ previewDialogOpen: false });

	handleMenuItemClick = (contentId:string, item:MenuData) => {
		switch(item.id) {
			case 1: {
				this.props.onSetDisplayNameClick(contentId);
			}
			break;
		}
	}

	render() {
		const { classes, onViewDetailsClick, userId, isInSelectedContent, setContentSelected, openConceptModel, assigmentCount, cardFlag, onScheduleClick } = this.props;
		const { previewDialogOpen, previewContent } = this.state;
		let content = (!this.props.content ? this.defaultContent : this.props.content);
		if (content.description == undefined) {
			content.description = ""
		}
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body'
		};

		const moreMenuItems: MenuData[] = [{
			type: 'callback',
			id: 1,
			to: '',
			img: '',
			text: 'Set Display Name',
		}]

		const contentStatus = this.getContentStatus();
		const getContentName = (content:any) => {
			let contentName = '';
			if (_.get(content, 'displayName', false)) {
				contentName = content.displayName;
			} else if(_.get(content, 'title', false)) {
				contentName = content.title;
			} else {
				contentName = content.name;
			}
			return contentName;
		}

		let startDate = new Date(content.testStartDate);
		let ddStartDate = startDate.getDate() .toString().padStart(2, "0");
		let mmStartDate = startDate.getMonth() + 1; 
		let yyyyStartDate = startDate.getFullYear();
 		let newStartDate = yyyyStartDate+"-"+mmStartDate+"-"+ddStartDate;

		 let endDate = new Date(content.testEndDate);
		 let ddEndDate = endDate.getDate().toString().padStart(2, "0");
		 let mmEndDate = endDate.getMonth() + 1; 
		 let yyyyEndDate = endDate.getFullYear();
 		let newEndDate = yyyyEndDate+"-"+mmEndDate+"-"+ddEndDate;

		return (
			<Paper className={classes.paper} elevation={1}>
				<Grid container>
					<Grid item xs={1} style={{ maxWidth: '6%', minWidth: '57px' }}>
						<Checkbox checked={isInSelectedContent(content._id, content.content_Id)} onChange={(a: any, b: any) => { setContentSelected(content, b) }} className={classes.checkbox} color="primary" disableRipple />
					</Grid>
					<Grid item xs={11}>
						<Grid container>
							<Grid item xs={6}>
								<Grid container>
									<Grid item xs={6}>
										<Typography variant="body2" className={cx(classes.title, classes.textEllipsis)}>{getContentName(content)}</Typography>
									</Grid>
									<Grid item xs={6}>
										<Chip color="primary" label={content.subtype == 'chap' ? 'Chapter Test' : content.subtype ? content.subtype : 'Test Papers'} className={classes.contentType} variant="outlined" />
									</Grid>
								</Grid>
								<Grid container>
									<Grid item xs={12} className={classes.textEllipsis}>
										<img src={this.contentTypeIcon[content.type]} className={classes.contentTypeIcon} />
										<Typography variant="body1" className={classes.subTitle}>

											<span dangerouslySetInnerHTML={{ __html: content.description.replace(/(<\/?(?:mark)[^>]*>)|<[^>]+>/ig, "$1") }}></span>

										</Typography>
									</Grid>
								</Grid>


							</Grid>
							<Grid item xs={1} style={{ alignSelf: 'center' }}>
								{this.renderContentStatus()}
							</Grid>

							<Grid item xs={3} style={{ alignSelf: 'center' }}>
								<div style={{ marginTop: "-4px" }} className="content-preview">
									{content.type == 'testpapers'
										? (
											<Button
												style={{ marginLeft: "-165px" }}
												variant="contained"
												size="small"
												className={classes.previewButton}
												key={content._id}
												onClick={this.handlePreviewDialogOpen.bind(this, content._id, content.type)}
											>
												<VisibilityIcon /> Preview
											</Button>
										)	: (
											<MyPATLink to={"/content/preview/" + content._id + content.type}>
												<Button
													style={{ marginLeft: "-165px" }}
													variant="contained"
													size="small"
													className={classes.previewButton}
												>
													<VisibilityIcon /> Preview
												</Button>
											</MyPATLink>
										)}
									<br />
									<Typography
										style={{ marginLeft: "-165px" }}
										onClick={(e: any) => { onViewDetailsClick(e, content) }}
										inline
										variant="body1"
										className={classes.viewDetails}
									>
										View Detail
									</Typography>
								</div>
							</Grid>

							<Grid item xs={2} style={{ alignSelf: 'center' }}>

								{(cardFlag == 'test' || content.type == "testpapers") ?
									<div style={{ whiteSpace: 'nowrap' }}>
										<Typography
											onClick={(e: any) => { onViewDetailsClick(e, content) }}
											inline variant="body1"
											className={classes.assigment}
										>
											Assignment- {assigmentCount}
										</Typography>
										{contentStatus === 'planned' && content.testStartDate === undefined ?  (
											<Button
												variant="outlined"
												size="small"
												className={classes.btnSchedule}
												onClick={(e: any) => { onScheduleClick(content._id) }}
											>
												<img src="/assets/img/course/calendar.png" />
												Schedule
											</Button>
										) : <span 
										style={{
											fontFamily: 'Roboto',
											color: '#999999',
											fontSize: '16px',
										}}>
											Schedule : {newStartDate}<div 
											style={{
												fontFamily: 'Roboto',
												color: '#999999',
												fontSize: '11px',
											}}
											>{content.testStartTime}&nbsp;<>to</>&nbsp;{newEndDate}&nbsp;,{content.testEndTime}</div></span>}
										
										{content.isUnlocked ? null : (
											<MyPATPopMenu
												id="content-more-menu"
												icon={MoreIcon}
												menuItem={moreMenuItems}
												clicked={this.handleMenuItemClick.bind(this, content._id)}
											/>
										)}
									</div>
									: ""}

							</Grid>
						</Grid>

					</Grid>
				</Grid>
				<MyPATDialog
					dialogOpen={previewDialogOpen}
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					customDialogTitle={
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs>
								<Typography variant="h5" align="left" className={classes.commentTitle}>Test Preview</Typography>
							</Grid>
							<Grid item xs="auto" className={classes.dialogCloseContainer}>
								<MyPATLink to={"/content/preview/" + this.state.previewTestKey + "testpapers"}>
									<MyPATIconButton buttonVariant="flat">
										<LaunchIcon />
									</MyPATIconButton>
								</MyPATLink>
								<MyPATIconButton buttonVariant="flat" onClick={this.handlePreviewDialogClose.bind(this)}>
									<CloseIcon />
								</MyPATIconButton>
							</Grid>
						</Grid>
					}
				>
					<TestPreview content={previewContent} />
				</MyPATDialog>
			</Paper>
		);
	}
}


const mapStateToProps = (state: any) => {
	let ct: any = _.get(state, "mylibraryData.contentType.list", []);
	let ctt: any = {};
	ct.forEach((c: any) => {
		ctt[c.code] = c.name;
	});


	let cst: any = _.get(state, "mylibraryData.contentSubtype.list", []);
	let cstt: any = {};
	cst.forEach((c: any) => {
		cstt[c.code] = c.name;
	});

	return {
		userId: _.get(state, "loginData.userData.authenticatedUser._id", "a"),
		contentType: ctt,
		contentSubtype: cstt,
	}
}

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(ContentCard));

